import React from 'react';
import { TbordOneToneIconVariant } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';

export enum COLUMN_TYPE {
  WARNING = 'warning',
  DEFAULT = 'default',
  SUCCESS = 'success',
  CONFIRMED = 'confirmed',
  PREPARATION = 'preparation',
  TRANSIT_TO_WAREHOUSE = 'transitToWarehouse',
  IN_WAREHOUSE = 'inWarehouse',
  TRANSIT_TO_DESTINATION = 'transitToDestination',
  DELIVERED = 'delivered'
}

export interface ITrelloColumnItem {
  orderId: number | string;
}

export interface ITrelloColumn {
  title: string;
  subtitle: string;
  variantIcon: TbordOneToneIconVariant;
  items: ITrelloColumnItem[];
  isLoading: boolean;
  content?: React.ReactNode;
  renderItem?: (item: ITrelloColumnItem) => React.ReactNode;
  columnType?: COLUMN_TYPE;
  isLoadingMoreItems?: boolean;
  hasMoreItems?: boolean;
  onLoadMore?: () => void;
  trelloColumnHeaderCustomClassName?: string;
}
